import axios from 'axios';
import {
  toCamelCase,
  toSnakeCase,
} from 'case-converter';
import Cookies from 'js-cookie';

class Request {
  constructor() {
    this.initConfig();
  }

  initConfig() {
    const token = Cookies.get('token');

    if (token) axios.defaults.headers.common.Authorization = `Token ${token}`;

    axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}api`;

    axios.interceptors.request.use(config => ({
      ...config,
      data: config.data ? toSnakeCase(config.data) : null,
    }));

    axios.interceptors.response.use(response => ({
      ...response,
      data: toCamelCase(response.data),
    }), error => Promise.reject(this.parseError(error)));
  }

  setAuthToken(token) {
    if (token) {
      Cookies.set('token', token, { expires: 365 });
      axios.defaults.headers.common.Authorization = `Token ${token}`;
    } else {
      Cookies.remove('token');
      axios.defaults.headers.common.Authorization = '';
    }
  }

  parseError(error) {
    const { response = {} } = error;
    const { data = {} } = response;

    return {
      ...error,
      response: {
        ...response,
        data: {
          ...toCamelCase(data),
          _error: data.non_field_errors || [],
        },
      },
    };
  }

  get(...args) {
    return axios.get(...args);
  }

  post(...args) {
    return axios.post(...args);
  }

  options(...args) {
    return axios.options(...args);
  }

  patch(...args) {
    return axios.patch(...args);
  }
}

export default new Request();



// WEBPACK FOOTER //
// ./src/utils/request.js